export enum ExpertBalanceSheetTab {
  Assets = 'assets',
  LiabilitiesAndEquity = 'liabilitiesAndEquity',
}

export enum ExpertBalanceSheetViewMode {
  Summary = 'summary',
  Detailed = 'detailed',
}

/** `account` rows only exist in the detailed view, each one following the group it belongs to. */
export type ExpertBalanceSheetRowKind = 'account' | 'line' | 'subtotal' | 'total'

export interface ExpertBalanceSheetTableRow {
  id: string
  kind: ExpertBalanceSheetRowKind
}

export interface ExpertBalanceSheetAssetRow {
  id: string
  label: string
  kind: ExpertBalanceSheetRowKind
  accountNumber?: string
  gross: (number | undefined)[]
  depreciation: (number | undefined)[]
  net: (number | undefined)[]
}

export interface ExpertBalanceSheetLiabilityRow {
  id: string
  label: string
  kind: ExpertBalanceSheetRowKind
  accountNumber?: string
  net: (number | undefined)[]
}

export interface ExpertBalanceSheetPeriodColumn {
  key: string
  label: string
  startDate: string
  endDate: string
}

export interface ExpertBalanceSheetAssetsViewData {
  periods: ExpertBalanceSheetPeriodColumn[]
  rows: ExpertBalanceSheetAssetRow[]
}

export interface ExpertBalanceSheetLiabilitiesViewData {
  periods: ExpertBalanceSheetPeriodColumn[]
  rows: ExpertBalanceSheetLiabilityRow[]
}

export interface ExpertBalanceSheetControl {
  imbalance: number
  isBalanced: boolean
}
